import React, { Component } from 'react';

export default class OrderHistoryItem extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <li key={this.props.key} className="ruled-list">
        <div className="col-70 list-header">{this.props.item.title}</div>
        <div className="col-30 text-right">${this.props.item.price}</div>
        <div className="left-spacing">Qty. {this.props.item.quantity}</div>
      </li>
    );
  }
};


// WEBPACK FOOTER //
// ./src/components/OrderHistoryItem.jsx